var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtdNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08594 14.6455V18.0455",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.166V18.0225",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.418 11.75V18.0297",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.40039V18.0364",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0859 5.0708V18.0344",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 14.25L14.168 3",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79297 3H14.168",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtdNeutral);
export default __webpack_public_path__ + "static/media/mtd-neutral.fb87b8d3fa8fd811a0d43d37fb9a0847.svg";
export { ForwardRef as ReactComponent };